<script lang="ts" setup>
import { onMounted, PropType, ref } from "vue";

const props = defineProps({
  urlProvider: {
    type: Function as PropType<() => string>,
    required: true
  },
  qrCodeLib: {
    type: Object as PropType<{
      toCanvas: (canvas: HTMLCanvasElement, url: string) => Promise<void>;
    }>,
    required: true
  }
});

const qrcodeCanvas = ref<HTMLCanvasElement>();

const renderQRCode = () => {
  if (qrcodeCanvas.value) {
    props.qrCodeLib.toCanvas(qrcodeCanvas.value, props.urlProvider());
  }
};

onMounted(() => {
  renderQRCode();
});
</script>

<template>
  <div>
    <canvas ref="qrcodeCanvas"></canvas>
  </div>
</template>
